"use client";
import {
  useHovercardDescription
} from "../__chunks/AYTT7WWV.js";
import "../__chunks/656RZDJD.js";
import "../__chunks/O37V6X5C.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-description.tsx
var TagName = "p";
var useMenuDescription = createHook(
  function useMenuDescription2(props) {
    props = useHovercardDescription(props);
    return props;
  }
);
var MenuDescription = forwardRef(function MenuDescription2(props) {
  const htmlProps = useMenuDescription(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuDescription,
  useMenuDescription
};
